import { api } from './client.js';

const root = '/admin/products';

export const productsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  remove: (id) => api.delete(`${root}/${id}`),
  setInventory: (id, body) => api.put(`${root}/${id}/inventory`, body),
  uploadMedia: (id, file, fields = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    Object.entries(fields).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
    return api.post(`${root}/${id}/media`, fd);
  },
  deleteMedia: (id, storageKey) => api.delete(`${root}/${id}/media`, { body: { storageKey } }),
  uploadContentImage: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(`${root}/${id}/content-media`, fd);
  },
  resolveContentMedia: (refs) => api.post(`${root}/content-media/resolve`, { refs }),
  // Parse a raw ingredient declaration into flat list + structured lines.
  parseIngredients: (text) => api.post(`${root}/parse-ingredients`, { text }),
  // Parse a raw label block into analytical constituents + additives.
  parseLabel: (text) => api.post(`${root}/parse-label`, { text }),
  // Variants of a base product.
  listVariants: (id) => api.get(`${root}/${id}/variants`),
  createVariant: (id, body) => api.post(`${root}/${id}/variants`, body),
  attachVariant: (id, body) => api.post(`${root}/${id}/variants/attach`, body),
  detachVariant: (id) => api.post(`${root}/${id}/detach`)
};
